function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "sampling");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-sampling",
  transform: "translate(-3.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M9.5,7.75107397 C9.5,5.0012812 6.92,3.24141383 6.81,3.17141911 C6.47168427,2.94275982 6.02831573,2.94275982 5.69,3.17141911 C5.58,3.25141308 3,5.0012812 3,7.75107397 C3,9.54586414 4.45507456,11.000829 6.25,11.000829 C8.04492544,11.000829 9.5,9.54586414 9.5,7.75107397 Z M6.25,9.00097977 C5.55964406,9.00097977 5,8.44137788 5,7.75107397 C5.08229108,6.80302337 5.53065101,5.92430413 6.25,5.30125859 C6.97363965,5.92093445 7.42295564,6.80152742 7.5,7.75107397 C7.5,8.44137788 6.94035594,9.00097977 6.25,9.00097977 L6.25,9.00097977 Z M12.31,10.1708916 C11.9716843,9.94223231 11.5283157,9.94223231 11.19,10.1708916 C11.02,10.2908826 7,13.0706731 7,17.2503581 C7,19.8735129 9.12664748,22 11.75,22 C14.3733525,22 16.5,19.8735129 16.5,17.2503581 C16.5,13.0006783 12.5,10.2808833 12.31,10.1708916 L12.31,10.1708916 Z M11.75,20.0001508 C11.0206547,20.0001508 10.3211814,19.7104413 9.80545635,19.1947552 C9.28973131,18.679069 9,17.9796484 9,17.2503581 C9,14.9405321 10.81,13.0806723 11.76,12.2507348 C12.7,13.0406753 14.5,14.8805367 14.5,17.2503581 C14.5,17.9796484 14.2102687,18.679069 13.6945436,19.1947552 C13.1788186,19.7104413 12.4793453,20.0001508 11.75,20.0001508 Z M18.56,2.17149447 C18.2216843,1.94283518 17.7783157,1.94283518 17.44,2.17149447 C17.3,2.27148693 14,4.55131511 14,8.00105513 C14,10.2100276 15.790861,12.0007537 18,12.0007537 C20.209139,12.0007537 22,10.2100276 22,8.00105513 C22,4.51131813 18.7,2.26148769 18.56,2.17149447 Z M18,10.0009044 C16.8954305,10.0009044 16,9.10554139 16,8.00105513 C16.1384532,6.54241329 16.8595351,5.20130191 18,4.28133546 C19.1449629,5.19756239 19.8671472,6.54072396 20,8.00105513 C20,9.10554139 19.1045695,10.0009044 18,10.0009044 Z",
  id: "sampling"
})));

var SvgSampling = function SvgSampling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSampling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sampling.07379380.svg";
export { ForwardRef as ReactComponent };